<template>
  <div id="app"> 
    <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>
      <yetkidialog ref="yetkidialog"></yetkidialog>
        <!-- <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp> -->
        <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
        <hotelloadingcomp ref="hotelloadingcomp" iconname="rv_hookup" v-bind:mesaj="loadingmesaj"  v-model="loadingdialog"></hotelloadingcomp>
           
        <v-dialog v-if="kisisecDialog" persistent v-model="kisisecDialog" max-width="300px">
            <v-card >
                <v-card-text>

                    <v-layout row wrap>
                        <v-flex xs12 pb-2 sm12 md12>
                            <v-layout row wrap class="project overdue">
                                <v-toolbar flat="" size="120px" dark color="white">
                                    <v-toolbar-title> <span class="subheading black--text">
                                            {{ $t('Person-List') }}
                                        </span> </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </v-layout>
                        </v-flex>
                         <!-- <v-flex pl-2 v-if="kisiListesiItems.length==0" xs12 md12 sm12>
                             <span class="grey--text">Eklenecek kayıt bulunamadı.</span>
                         </v-flex> -->

                        <v-flex pt-2 xs12 md12 sm12 >
                            <v-list v-for="element in kisiListesiItems" :key="element.id">
                                <v-list-tile>
                                    <v-layout row wrap>
                                        <v-flex xs12 md10 sm10>
                                            <v-layout row full-width fill-height justiy-start align-center>

                                                <v-icon v-if="element.tip!=1 && element.tip!=2" color="grey">person
                                                </v-icon>
                                                <v-icon v-if="element.tip==1" color="grey">face</v-icon>
                                                <v-icon v-if="element.tip==2" color="grey">child_care
                                                </v-icon>

                                                &nbsp;
                                                <span class="grey--text">
                                                    {{element.adSoyad}}
                                                </span>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 md2 sm2>
                                            <v-layout column fill-height align-center>
                                                <v-btn color="green" flat v-if="getEklimi(element)"
                                                    :disabled="!getkisiDurum(element.tip)" @click="kisiAktar(element)">
                                                    {{ $t('Select') }}
                                                </v-btn>
                                                <v-btn color="red" :disabled="!getkisiDurum(element.tip)" flat
                                                    v-if="!getEklimi(element)" @click="kisiKaldir(element)">
                                                    {{ $t('Remove') }}
                                                </v-btn>
                                            </v-layout>

                                        </v-flex>

                                    </v-layout>


                                </v-list-tile>
                                <v-divider></v-divider>
                            </v-list>

                        </v-flex>

                    </v-layout>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" flat="flat" @click.native="kisisecDialog = false">{{$t("cancel_button")}}</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card color="grey lighten-5" flat v-if="this.kayitvarmi">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title> Transfer Detayları</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat @click="Rezgonder()"> <span class="hidden-sm-and-down"> Rezervasyon Yap </span>
                            <v-icon right dark>add_box</v-icon>
                        </v-btn> -->
                    </v-toolbar>
                </v-flex>
            </v-layout>
        </v-card>
        <v-form ref="formtransfer" v-model="validform" lazy-validation>
            <v-card color="grey lighten-5" flat>
                <v-layout row wrap>
                 
                     
                    <v-flex pa-1 xs12 sm12 md9>
                        <v-layout row wrap>
                       <v-flex pt-2 xs12 sm12 md12>
                                <v-card style="border: 1px solid #d0d0d0 !important;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                                    <v-layout row wrap>

                                        <v-flex xs12 pa-2 sm12 md12>
                                            <v-layout row wrap class="project overdue">
                                                <v-toolbar flat="" size="120px" dark color="white">
                                                    <v-toolbar-title>
                                                        <span class="black--text font-weight-bold">
                                                            <v-icon color="primary">people_alt</v-icon> {{ $t('Passenger-Details') }}
                                                        </span>
                                                    </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                            </v-layout>
                                        </v-flex>
                                       

                                        <v-flex xs12 sm12 pl-1 md12>
                                            <v-flex v-for="item in kisiBilgileri" :key="item.id">
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md2>
                                                        <v-layout align-center
    justify-center
    row
    fill-height>
                                                            <v-chip @click="kisisec(item)" outline class="ma-2"
                                                                color="green" text-color="green">
                                                                <v-icon v-if="item.tip==0" color="green">person</v-icon>
                                                                <v-icon v-if="item.tip==1" color="green">face</v-icon>
                                                                <v-icon v-if="item.tip==2" color="green">child_care
                                                                </v-icon>
                                                                &nbsp;
                                                                <span v-if="item.tip==0"> {{ $t('Adult') }}  </span>
                                                                <span v-if="item.tip==1"> {{ $t('Child') }} </span>
                                                                <span v-if="item.tip==2"> {{ $t('Baby') }}</span>

                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md10>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm12 md2>
                                                                <v-text-field :disabled="item.CoperKisiID!=null"
                                                                    :label="$t('Name_label')" :rules="[v => !!v || $t('Mandatory-section')]"
                                                                    v-model="item.Ad">
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md2>
                                                                <v-text-field :label="$t('Surname_label')"
                                                                    :disabled="item.CoperKisiID!=null"
                                                                    :rules="[v => !!v || $t('Mandatory-section')]"
                                                                    v-model="item.Soyad">
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md2>
                                                                <v-text-field label="Kimlik/Pasaport No"
                                                                    :rules="[v => !!v || $t('Mandatory-section')]"
                                                                    v-model="item.TcKimlikNo"></v-text-field>
                                                            </v-flex>
                                                           
                                                            <v-flex v-if="item.id==0" xs12 sm12 md3>
                                                                <v-text-field :label="$t('Email_label')"
                                                                    :rules="[v => !!v || $t('Mandatory-section')]"
                                                                    v-model="item.Email">
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 v-if="item.id==0" md3>
                                                                <v-text-field :label="$t('Telephone')"
                                                                    :rules="[v => !!v || $t('Mandatory-section')]"
                                                                    v-model="item.Phone">
                                                                </v-text-field>
                                                            </v-flex>


                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-flex>


                                    </v-layout>
                                </v-card>

                            </v-flex>
                              <v-flex xs12 sm12 md12 pt-2>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-card style="border: 1px solid #d0d0d0 !important;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                                            <v-flex pa-2 xs12 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-layout row wrap class="project overdue">
                                                            <v-toolbar flat="" size="120px" dark color="white">
                                                                <v-toolbar-title>
                                                                    <span class="black--text font-weight-bold">
                                                                        <v-icon color="primary">location_on</v-icon>
                                                                        {{TransferResult.PickupPointName}}
                                                                    </span>
                                                                </v-toolbar-title>
                                                                <v-spacer></v-spacer>
                                                            </v-toolbar>
                                                        </v-layout>

                                                        <v-flex xs12 sm12 md12>
                                                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                                :label="$t('Flight-No')" v-model="TransferData.FlightNumber">
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-textarea label="Alınacak Yer Açıklama"
                                                                v-model="TransferData.PickupPointInfo"></v-textarea>
                                                        </v-flex>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-layout row wrap class="project overdue">
                                                            <v-toolbar flat="" size="120px" dark color="white">
                                                                <v-toolbar-title>
                                                                    <span class="black--text font-weight-bold">
                                                                        <v-icon color="primary">location_on</v-icon>
                                                                        {{TransferResult.DropPointName}}
                                                                    </span>
                                                                </v-toolbar-title>
                                                                <v-spacer></v-spacer>
                                                            </v-toolbar>
                                                        </v-layout>




                                                        <v-flex xs12 sm12 md12>
                                                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                                :label="$t('Address_label')" v-model="TransferData.Adress">
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-textarea :label="$t('Explanation-Drop-off-Place')"
                                                                v-model="TransferData.DropPointInfo"></v-textarea>
                                                        </v-flex>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-textarea :label="$t('Reservation-Note')"
                                                            v-model="TransferData.BookingInfo"></v-textarea>
                                                    </v-flex>

                                                </v-layout>

                                            </v-flex>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex v-if="islemTipi !='pdget'" pb-2 pt-2 xs12 sm12 md12>
                                <v-card style="border: 1px solid #d0d0d0 !important;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);">

                                    <v-card-title primary-title>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 pt-2 md12>
                                                <v-layout row wrap class=" project overdue">
                                                    <v-toolbar flat="" size="120px" dark color="white">
                                                        <v-toolbar-title>
                                                            <span class="headline black--text font-weight-bold">
                                                                {{ $t('Current-Details') }}
                                                            </span>
                                                        </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex pl-4 xs12 sm12 md12>
                                                <caricomp v-bind:autofocuss="true" :Coper="true"
                                                    v-bind:statecariyedek="stateCari"
                                                    v-bind:zorunlumu="true"
                                                    v-model="cariKod">
                                                </caricomp>

                                            </v-flex>

                                        </v-layout>
                                    </v-card-title>

                                </v-card>
                            </v-flex>

                          



                            
                        </v-layout>
                    </v-flex>
                           <v-flex pa-1 xs12 sm3 md3 style="margin-top: 8px;">
                        <v-card style="border: 1px solid #d0d0d0 !important;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                            <v-img :src="TransferResult.PhotoPath" height="250px"></v-img>
                            <v-layout row wrap>
                                <v-card-title primary-title>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <span class="headline black--text font-weight-bold">
                                                {{TransferResult.Title}}
                                            </span>
                                        </v-flex>
                                        <v-flex pt-1 xs12 sm12 md12>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <!-- <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md6>
                                                    <span class='font-weight-medium' style="padding-top:20px">
                                                        <v-icon color="primary">supervisor_account</v-icon>
                                                        {{TransferResult.MaxPax}} Yolcu
                                                    </span>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6>
                                                    <span class='font-weight-medium' style="padding-top:20px">
                                                        <v-icon pl-5 color="primary">work</v-icon>
                                                        {{TransferResult.MaxSuitcase}}
                                                    </span>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex> -->
                                        <v-flex xs12 sm12 md12>
  <v-layout row wrap pt-2>
    <v-flex xs12 sm12 md6>
      <v-layout row align-center>
        <v-icon color="primary" class="mr-2">supervisor_account</v-icon>
        <span class="font-weight-medium">{{ TransferResult.MaxPax }} Yolcu</span>
      </v-layout>
    </v-flex>

    <v-flex xs12 sm12 md6>
      <v-layout row align-center>
        <v-icon color="primary" class="mr-2">work</v-icon>
        <span class="font-weight-medium">{{ TransferResult.MaxSuitcase }}</span>
      </v-layout>
    </v-flex>
  </v-layout>
</v-flex>
                                        <v-flex pt-1 xs12 sm12 md12>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex pt-1 xs12 sm12 md12>
                                          <span class='font-weight-medium' style="padding-top:20px">
                                                        <v-icon pl-5 color="primary">calendar_month</v-icon>
                                                        {{ TransferResult.TransferInfo.DateAndTime }} 
                                                    </span>
                                            <span class="font-weight-medium black--text">
                                            
                                          
                                                <!-- {{TransferResult.TransferInfo.DateAndTime | dateformat}} -
                                                {{TransferResult.TransferInfo.DateAndTime | gettime}} -->
                                            </span>
                                        </v-flex>
                                        <v-flex pt-1 xs12 sm12 md12>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <v-flex xs12 pt-1 sm12 md12>
                                            <v-layout align-center>
                                                <v-icon small color="green">check
                                                </v-icon>
                                                &nbsp;
                                                <span class="green--text">    
                                                  {{ 'Son' }} {{ TransferResult.FreeCancelHourBefore }} {{ 'saate kadar iptal hakkı' }}
                                                   
                                                </span>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex pt-1 xs12 sm12 md12>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <v-flex xs12 pt-1 sm12 md12>
                                            <v-layout align-center>
                                                <v-icon small color="green">check
                                                </v-icon>
                                                &nbsp;<span class="green--text">
                                                  {{ 'Son' }} {{ TransferResult.FreeCancelHourBefore }} {{ 'saate kadar değişiklik hakkı' }}
                                                </span>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex pt-1 xs12 sm12 md12>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <v-flex xs12 pt-1 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs3 sm3 md4>
                                                    <v-layout row wrap align-center>
                                                        <v-icon color="grey">person</v-icon>&nbsp;<span
                                                            class="grey--text">
                                                            {{TransferResult.TransferInfo.AdultCount}} {{ $t('Adult') }} </span>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs3 sm3 md4>
                                                    <v-layout row wrap align-center>
                                                        <v-icon color="grey">face</v-icon>&nbsp;<span
                                                            class="grey--text">
                                                            {{TransferResult.TransferInfo.ChildCount}} {{ $t('Child') }} </span>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs3 sm3 md4>
                                                    <v-layout row wrap align-center>

                                                        <v-icon color="grey">child_care</v-icon>&nbsp;<span
                                                            class="grey--text">
                                                            {{TransferResult.TransferInfo.BabyCount}} Bebek</span>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                    </v-layout>

                                    <v-flex xs12 pt-4 sm12 md12>
                                        <v-layout row wrap align-center>

                                            <span class="black--text"> {{ $t('Price-Details-v2') }} </span>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-divider></v-divider>
                                    </v-flex>

                                   
                                    <v-flex xs12 sm12 md12>
                                        <v-layout row wrap>
                                          <v-flex xs6 sm6 md6 mt-2>
                                            <parainput
                                      :isPositive="true" 
                                      :simge="getparabirimi()"
                                      v-model="TransferResult.PriceDetails.SystemPrice"
                                      :autocomplete="'autocomplete'"
                                      :reverse=true
                                      
                                      :etiket="$t('Cost')"
                                    ></parainput>
                                         
                                                <!-- <div class="caption">  {{ $t('Markup-Amount') }}
                                                </div> -->
                                            </v-flex>
                                            <v-flex xs6 sm6 md6 mt-2>
                                              <parainput
                                      :isPositive="true" 
                                      :simge="getparabirimi()"
                                      v-model="TransferResult.PriceDetails.Markup"
                                      :autocomplete="'autocomplete'"
                                      :reverse=true
                                     
                                      :etiket="$t('Markup-Amount')"
                                    ></parainput>
                                                  
                                                 
                                                
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                 

                                    <v-flex xs12 sm12 md12 mt-2>

                                      <v-layout row wrap>
                                            <!-- <v-flex xs6 sm6 md6 mt-4>
                                                <div class="title">  {{ $t('totalamount') }}
                                                </div>
                                            </v-flex> -->
                                            <v-flex xs12 sm12 md12 >
                                              <parainput
                                      :isPositive="true" 
                                      :simge="getparabirimi()"
                                      v-model="TransferResult.PriceDetails.UserPrice"
                                      :autocomplete="'autocomplete'"
                                      :reverse=true
                                      :aktif="'false'"
                                       :etiket="$t('totalamount')"
                                    ></parainput>
                                             

                                             
                                               
                                          
                                         
                                     </v-flex>
                                         
                                        </v-layout>

                                       
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 mt-3>
                                        <v-btn color="green" v-if="demoKayit" @click="TransferKaydetv3()" block><span class="white--text">

                                          {{ $t('Complete-Reservation') }}      
                                          </span>
                                        </v-btn>
 
                                        <v-btn
                                          color="blue-grey"
                                          class="white--text"
                                          @click="irtibatDialog()"
                                          block
                                          v-else
                                        >
                                          {{ $t('CONTACT-US') }}
                                          <v-icon right dark>contact_mail</v-icon>
                                        </v-btn>
                                    </v-flex>

                                </v-card-title>

                            </v-layout>

                        </v-card>

                    </v-flex>
                </v-layout>
            </v-card>
        </v-form>
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import parainputevents from "@/components/app/customcomp/parainputevents";
import parainput from "@/components/app/customcomp/parainput";
import tool from "../../coper/tools";
export default {
data() {
  return {
    prmPaxDriveAcenteKod:'',
    demoKayit:true,
    secilenKisiTip: null,
    secilenKisi: null,
    kisisecDialog: false,
    isimDefault: true,
    kisiListesi: [],
    kisiListesiItems: [],
    stateCari: [],
    kisiTipiItems: [],
    kisiBilgileri: [],
    cariKod: null,
    islemTipi: null,
    yetkidialog:false,
    sayfayetki: {
      Screen: false,
      Update: false,
      Save: false,
      Delete: false,
      Status: false,
      Message: null,
      islem: 0,
    },
    loadingmesaj: "",
    loadingdialog: false,
    snackbar: false,
    text1: null,
    ulkeitems: [],
    search: [],
    validform: true,
    odadetaydialog: false,
    odadetayi: {},
    kayitvarmi: false,
    onerilenkayitvarmi: false,
    yetiskinSayi: 1,
    Azalt: false,
    toplamFiyat: 0,
    menu: false,
    loadodaitems: null,
    adultItems: 0,
    childItems: 0,
    babyItems: 0,
    siralamatipiitems: [
      {
        text: this.$t("Price-Ascending"),
        value: "Price",
      },
      {
        text: this.$t("Price-Descending"),
        value: "PriceDesc",
      },
    ],
    kayitsayisi: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
    ],
    items: [
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
      },
    ],
    yetiskinitems: [],
    yetiskinkisibilgileri: [],
    cocukkisibilgileri: [],
    bebekkisibilgileri: [],
    TransferData: {
      FlightNumber: "",
      Adress: "",
      DropPointInfo: null,
      PickupPointInfo: null,
      BookingInfo: null,
    },
    TransferResult: {
      ProductId: null,
      Id: null,
      VehicleId: 0,
      ResponseId: 0,
      PickupPointId: 0,
      DropPointId: 0,
      PickupPoint: null,
      PickupPointName: null,
      DropPoint: null,
      Title: null,
      MaxPax: null,
      MaxSuitcase: null,
      BookingHour: null,
      FreeCancelHourBefore: null,
      FreeChangeHourBefore: null,
      PhotoPath: "",
      PriceDetails: {
        Markup: 0.0,
        SystemMarkup:0.0,
        SystemPrice: 0.0,
        UserPrice: 0.0,
        DisplayPrice: 0.0,
      },
      PaxDetails: [],
      ExpireAt: null,
      TransferInfo: {
        AdultCount: 0,
        ChildCount: 0,
        BabyCount: 0,
        DateAndTime: null,
      },
    },
  };
},
mounted() {

 
  this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

  if (this.sayfayetki.Status == true) {
    //YETKİ OK
    this.getProviders();
    if (
    this.$route.query.islemTipi != undefined &&
    this.$route.query.islemTipi != null
  ) {
    if (this.$route.query.islemTipi == "pdget") {
      this.islemTipi = "pdget";
    } else {
      this.islemTipi = "pdyeni";
    }
  } else {
    this.islemTipi = "pdyeni";
  }
 
  this.loadingdialog = true;
  this.loadingmesaj = this.$t('Your-transfer-details-are-being-accessed');

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
   var bookingParams = JSON.parse(
          window.localStorage.getItem("transferBookingParams")
        );
        var params={
        SessionHeader:{
      SessionId: bookingParams.SessionId,
      SessionToken:bookingParams.SessionToken
    },
  
 
    //ShoppingCartId:null,
    ResponseId: this.$route.query.responseId,
    ProductId: this.$route.query.vehicleId,
    Quantity: 1,
     AdultCount: this.$route.query.adultCount,
     ChildCount: this.$route.query.childCount,
     BabyCount: this.$route.query.babyCount,
    DateAndTime: this.$route.query.dateAndTime,
    // ProductId: this.$route.query.vehicleId,
     MarkupCurrency: this.$route.query.markupCurrency,
  };

  this.$http
    .post(auth.BOOKING_API_URL + "Transfer/Allocate", params, {
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
          ),
      },
    })
    .then(
      (response) => {
        if (response.body.Status == false) {
           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true;
          this.progress = false;
        } else {



          var result = response.body.ShoppingCart.TransferBookings[0].Vehicle;
         
         
     

          this.TransferResult.ProductId=result.ProductId;
          this.TransferResult.vehicleId=0;
          this.TransferResult.Id=0;
          this.TransferResult.ResponseId=0;
          this.TransferResult.PickupPointId=result.PickupPointId;
          this.TransferResult.DropPointId=result.DropPointId;

          this.TransferResult.PickupPoint= this.$route.query.pickupText;
          this.TransferResult.DropPoint=this.$route.query.dropText;
          this.TransferResult.PickupPointName = this.$route.query.pickupText;
          this.TransferResult.DropPointName = this.$route.query.dropText;
          this.TransferResult.Title=result.Title;
          this.TransferResult.MaxPax=result.MaxPax;
          this.TransferResult.MaxSuitcase=result.MaxSuitcase;
          this.TransferResult.BookingHour= result.BookingHour;
         this.TransferResult.FreeCancelHourBefore= result.FreeCancelHourBefore;
         this.TransferResult.FreeChangeHourBefore= result.FreeChangeHourBefore;
     this.TransferResult.PhotoPath="https://partner.paxdrive.com" + result.PhotoPath;
    this.TransferResult.PriceDetails=result.PriceDetails;
    this.TransferResult.PaxDetails=result.PaxDetails;


        

          this.TransferResult.TransferInfo.AdultCount = this.$route.query.adultCount;
          
      this.TransferResult.TransferInfo.ChildCount= this.$route.query.childCount;
     this.TransferResult.TransferInfo.BabyCount= this.$route.query.babyCount;
          this.TransferResult.TransferInfo.DateAndTime = this.$route.query.dateAndTime;
          
         

          this.kisiListesiItems = [];
         
          var pdtransfer = JSON.parse(
            window.localStorage.getItem("pdtransfer")
          );

          if (pdtransfer != null && this.islemTipi == "pdget") {
            pdtransfer.Rezervasyon.adresler.forEach((element) => {
              var index = pdtransfer.Rezervasyon.adresler.indexOf(element);

              var kayit = {
                id: index,
                adSoyad: element.adSoyad,
                tip: element.kisiTip,
              };

              this.kisiListesiItems.push(kayit);
            });
          } else {
          }
        }
       
        this.loadingdialog = false;
        
      },
      (response) => {
        this.text1 = "Transfer arama yapılırken hata meydana geldi.";
        this.snackbar = true;
        this.progress = false;
        this.loadingdialog = false;
      }
    );

  var i, k, j;
   this.kisiTipiItems = [];
   
  var top =
    parseInt(this.$route.query.adultCount) +
    parseInt(this.$route.query.childCount) +
    parseInt(this.$route.query.babyCount);
    
  // yetişkin tip 0, çocuk 1 ,baby 2

  for (i = 0; i < this.$route.query.adultCount; i++) {
    var kayit = {

      id: i,
      tip: 0,
    };
    
    this.kisiTipiItems.push(kayit);
  }
 
  for (
    k = i;
    k <
    parseInt(this.$route.query.adultCount) +
      parseInt(this.$route.query.childCount);
    k++
  ) {
    var kayit = {
      id: k,
      tip: 1,
    };
    this.kisiTipiItems.push(kayit);
  }
  
  for (j = k; j < top; j++) {
    var kayit = {
      id: j,
      tip: 2,
    };
    this.kisiTipiItems.push(kayit);
  }
  
  this.kisiBilgileri = [];

   i = 0;
  
  this.kisiTipiItems.forEach((element) => {
    var yeni = {
      sira: null,
      id: parseInt(i),
      tip: element.tip,
      Ad: null,
      Soyad: null,
      TcKimlikNo: null,
      Ulke: null,
      CoperKisiID: null,
    };
    this.kisiBilgileri.push(yeni);
    i++;
  });
  } else {
    this.$refs.yetkidialog
      .open(this.sayfayetki.Message, this.sayfayetki.islem)
      .then((sonuc) => {
        if (sonuc == true) {
          if (this.prevRoute != null) {
            var url = "#" + this.prevRoute;

            window.open(url, "_self");
          } else {
            var mainUrl = "#/";
            window.open(mainUrl, "_self");
          }
        }
      });
  }
  
},
beforeMount: beforeMount,
methods: {
   getProviders()
    {
     let itemsproviders=[];
      var bookingParams = JSON.parse(
          window.localStorage.getItem("transferBookingParams")
        );
        var params={
        SessionHeader:{
      SessionId: bookingParams.SessionId,
      SessionToken:bookingParams.SessionToken
    }};
 
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
          console.log(response.body);
            var rsp=response.body.Credentials;
           rsp.forEach(element => {
            if (element.ProviderType=='Transfer' && element.Provider=="Paxdrive")
           {
            this.prmPaxDriveAcenteKod=element.OfficeId;
           }
   
});

            this.loadingdialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            }
          }
        );
    },
  toIsoDateTime(val) {
  if (!val) return null;

  
  return val.replace(" ", "T") + ":00";
},
//     login()
//       {
        
//         this.loadingvmodel = true;
//         var params = {
//           Username: "Arkgsa",
//     Password: "3paPVcsbbpf5Lwj",
//     IsTest: true
  
//         };
  
//         this.$http
//           .post( auth.BOOKING_API_URL + "Login", params, {
//             headers: {
//               Authorization: "Bearer " + auth.getAuthHeader(),
//             },
//           })
//           .then(
//             (response) => {
           
//              this.SessionId=response.body.SessionId;
//              this.SessionToken=response.body.SessionToken;
             
//              window.localStorage.setItem(
//               "transferBookingParams",
//               JSON.stringify(response.body)
//             );

//               this.loadingvmodel = false;

// console.log(response.body.SessionId);
// console.log(response.body.SessionToken);

//             },
//             (response) => {
//               if (response.status === 0) {
//                 this.text1 = "Service Unavailable";
//                 this.loadingvmodel = false;
//                 this.snackbar = true;
//               } else {
//                 this.text1 = "Service Unavailable";
//                 this.loadingvmodel = false;
//                 this.snackbar = true;
//               }
//             }
//           );
//       },
 async TransferKaydetv3() {
   await this.TransferAllocate();
   await this.UpdatePassengers();
   await this.MakeReservation();
    await this.sendNext();
    
    },
 async TransferAllocate() {
  this.loadingdialog=true;
  const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

  const params = {
    SessionHeader: {
      SessionId: bookingParams.SessionId,
      SessionToken: bookingParams.SessionToken,
    },
    ProductId: this.$route.query.vehicleId,
    Quantity: 1,
  };

  console.log(params);

  try {
    const response = await this.$http.post(
      auth.BOOKING_API_URL + "Transfer/Allocate",
      params,
      {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
        },
      }
    );

    this.ShoppingCartId = response.body.ShoppingCart.Id;
    this.PaxReferanceId=response.body.ShoppingCart.TransferBookings[0].PassengerBreakdowns[0].PaxReference.PaxReferanceId;

   
    console.log("Transfer allocate tamamlandı");
  } catch (error) {
    console.error("Transfer allocate başarısız:", error);
    this.loadingdialog=false;
    
  }
},

 async MakeReservation() {
  this.loadingdialog=true;
  const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

  const params = {
    SessionHeader: {
      SessionId: bookingParams.SessionId,
      SessionToken: bookingParams.SessionToken,
    },
    ShoppingCartId: this.ShoppingCartId,
    BaggageAllowance: "",
    LinkUrl: "",
    SelectedServiceFee: 0,
    ContinueWithoutReservation: true,
  };

  try {
    const response = await this.$http.post(
      auth.BOOKING_API_URL + "Transfer/MakePreBooking",
      params,
      {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
        },
      }
    );
if (!response.HasError) {
 console.log("Rezervasyon yapıldı:", response.body);
          
              this.loadingdialog=false;
}else{
 console.error("Rezervasyon başarısız:", error);
  this.text1 = "Rezervasyon Başarısız Oldu Bir Süre Sonra Tekrar Deneyiniz...";
           this.loadingdialog=false;
            this.snackbar = true;
}
   

  } catch (error) {
    this.loadingdialog=false;
    console.error("Rezervasyon başarısız:", error);
    throw error;
  }
},
async UpdatePassengers() {
  let yolcular=[];
  const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));
   this.kisiBilgileri.forEach((element) => {
    var paxtype="Adult";
    var ischild=false;
    if (element.tip==1){
      paxtype="Child";
      ischild=true;
    }
     if (element.tip==2){
      paxtype="Baby";
      ischild=true;
    }
    
      var yeniyolcu = {
       FirstName: element.Ad,
      LastName: element.Soyad,
      PaxType: paxtype,
      Gender: 'Male',
      BirthDate: '1980-01-01',
      Email: element.Email,
      Phone: element.Phone,
      CitizenNo: element.TcKimlikNo,
      PassportNo: '',
      PassportExpireDate: '',
      Nationality: element.Ulke,
      HesCode: '',
      FrequentFlayerNo: '',
      WheelChairService: 0,
      PaxReferanceId: this.PaxReferanceId,
      ExtraPosAmount: 0.0,
      isChild: ischild,
      Address: '',
      AddressCountry: '',
      AddressCity: '',
      SelectedShuttle: null,
      };
      yolcular.push(yeniyolcu);
     
    });
 

  const params = {
    SessionHeader: {
      SessionId: bookingParams.SessionId,
      SessionToken: bookingParams.SessionToken,
    },
    ShoppingCartId: this.ShoppingCartId,
    CorporatePin: '',
    Contact: {
      Name: yolcular[0].FirstName,
      LastName: yolcular[0].LastName,
      Phone: yolcular[0].Phone,
      Email: yolcular[0].Email,
    },
    Passengers: yolcular,
    ReturnPassengers: null,
    EArchiveWebAddress: 88,
    Notes: this.TransferData.BookingInfo,
    PickupPointExplanation: this.TransferData.PickupPointInfo,
    DropPointExplanation: this.TransferData.DropPointInfo,
  };

  try {
    const response = await this.$http.post(
      auth.BOOKING_API_URL + "Transfer/UpdatePassengers",
      params,
      {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
        },
      }
    );

    console.log("Yolcular başarıyla güncellendi");

  } catch (error) {
    console.error("Yolcu güncelleme hatası:", error);
    throw error;
  }
},
   durdurGonderim() {
    this.stopRequested = true;
  },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

  

    async sendNext(){
      this.loadingdialog=true;
      var sira=0;
      var yolcular=[];
this.kisiBilgileri.forEach((element) => {
    
      var yeniyolcu = {
         id: -1,
      kisiTip: element.Type,
      kisiSira: sira,
      yas: 0,
      profilId: 0,
      sicilId: 0,
      tcKimlikNo: element.TcKimlikNo,
      uyeNo: "",
      lastName: element.Soyad,
      firstName: element.Ad,
      adSoyad: element.Ad + ' ' + element.Soyad,
      adres: "",
      dogumTarihi: null,
      cinsiyet: "",
      telefon1: "",
      gsm: element.Phone,
      eMail: element.Email
      
      };
      yolcular.push(yeniyolcu);
     sira+=1;
    });
    
 var Rezervasyonprm = {
  pNR_No: 0,
  MisafirIsmiKontrolEdilmesin: false,
  Status: 0,
  FaturaBilgileri: [],
  kayitTarihi: tool.Now_yyyy_MM_dd(),
  cariKod: {
    id: "",
    kod: this.cariKod,
    isim: "",
    isimAra: ""
  },
  rezVeren: "",
  masrafMerkezi: {
    id: "",
    kod: "",
    isim: "",
    isimAra: ""
  },
  anaTip: 0,
  ulke: null,
  karsiRezKod: "",
  turKod: "",
  acenteDepartman: {
    id: "",
    kod: "",
    isim: "",
    isimAra: ""
  },
  hizmetNo: "",
  referansKod: "",
  adresler:yolcular,
  kalemler: [
    {
      islemRef: 0,
      saticiEntegrasyon: null,
      entTip: null,
      entId: null,
     donem1: this.toIsoDateTime(this.$route.query.dateAndTime),
     donem2: this.toIsoDateTime(this.$route.query.dateAndTime),
      satis: {
        KDVOran: 10
      },
      alis: {
        KDVOran: 0
      },
      komisyon: {
        KDVOran: null,
        tutar: 0
      },
      acenteKomisyon: null,
      iskonto: {
        oran: 0,
        tutar: 0,
        iskontoSebebi: null
      },
      odeyenTaraf: 1,
      aciklama: null,
      tedarikciAciklama: null,
      turOperatoru: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      departman: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      kdvID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      kdvMuafiyetID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      entegrasyonKodu: null,
      maliyetCariKod: {
        id: null,
        kod: null,
        isim: null,
        tip: null
      },
      saticiTip: 2,
      kisiSira: [0],
      yet_Satis: this.TransferResult.PriceDetails.SystemPrice,
      co1_Satis: 0,
      co2_Satis: 0,
      co3_Satis: 0,
      co4_Satis: 0,
      ekY_Satis: 0,
      yet_Alis: 0,
      co1_Alis: 0,
      co2_Alis: 0,
      co3_Alis: 0,
      co4_Alis: 0,
      ekY_Alis: 0,
      yet_KisiSayisi: 1,
      co1_KisiSayisi: 0,
      co2_KisiSayisi: 0,
      co3_KisiSayisi: 0,
      co4_KisiSayisi: 0,
      ekY_KisiSayisi: 0,
      satici: {
        id: "",
        isim: "",
        KDV: 10,
        kod: this.prmPaxDriveAcenteKod,
        CariKod: "",
        YurtIci_YurtDisi: 0,
        isimAra: ""
      },
      alisPara: {
        paraBirimi: "TL",
        kur: 1,
        kurTarihi: null
      },
      satisPara: {
        paraBirimi: "TL",
        kur: 1,
        kurTarihi: null
      },
      komisyonPara: {
        paraBirimi: "TL",
        kur: 1,
        kurTarihi: null
      },
      komisyonYuzdeTip: 0,
      komisyonYuzde: 0,
      komisyonTutar: 0,
      P_RP: "P",
      KKartNo: null,
      KKartOdemeTipi: 0,
      masrafMerkezi: {
        id: "",
        kod: "",
        isim: "",
        isimAra: ""
      },
      kalemOtel: null,
      kalemArac: {
        tip: null,
        ucusNo: this.TransferData.FlightNumber,
        ucusSaat: null,
        tasimaTipi: null,
        bolge: null,
        nerden: this.TransferResult.PickupPointName,
        nereye: this.TransferResult.DropPointName,
        arac: null,
        aracAdet: null,
        rehberDili: null,
        rehberAdet: null,
        seferNo: null,
        seferId: null,
        seferSaat: null,
        ADT: null,
        tasimaTipRef: null,
        rehber: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null
        },
        pinCode: null,
        otelKod: null,
        SoforTahsilat: null,
        seferVarisId: null,
        odaNo: null,
        transferDurumu: null
      },
      kalemRestaurant: null,
      kalemMuze: null,
      kalemDiger: null,
      kalemRentACar: null,
      kalemVize: null,
      kalemSigorta: null,
      kalemGemi: null,
      kalemRehber: null,
      kalemAcente: null,
      kalemCharter: null,
      kalemFeribot: null,
      kalemGolf: null
    }
  ],
  odemeler: [],
  toplamTL: {
    satis: 0,
    alis: 0,
    komisyon: 0,
    iskonto: 0
  },
  opsiyonluMusteri: false,
  opsiyonTarihi: null,
  opsiyonSaati: null,
  acente: {
    id: null,
    kod: this.prmPaxDriveAcenteKod,
    isim: null,
    isimAra: this.prmPaxDriveAcenteKod,
    YurtIci_YurtDisi:0,
    KDV:10,

  }
};
tool.http_post(this, "RezervasyonKaydet", { Rezervasyon: Rezervasyonprm }).then(response => {
        console.log("RezervasyonKaydet Response:", response.body);

        if (response.body.Status == true) {
             this.text1 = "Rezervasyon İşleminiz Tamamlandı.";
            this.snackbar = true;

            // PNR numarası ile rezervasyon detay sayfasına yönlendir
            var pnrNo = response.body.data ? response.body.data.pNR_No : response.body.pNR_No;
            console.log("PNR No:", pnrNo);
            if (pnrNo) {
              var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + pnrNo;
              window.open(url, "_target");
            } else {
              // PNR bulunamazsa eski davranışa geri dön
              console.warn("PNR numarası bulunamadı, paxdrive/index sayfasına yönlendiriliyor");
              setTimeout(
                function () {
                  var url = "/#/coper/paxdrive/index/id";
                  location.href = url;
                  location.reload();
                }.bind(this),
                3000
              );
            }

        } else {

this.loadingdialog=false;
            console.error("RezervasyonKaydet Hata:", response.body.ErrorList);
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;


        }
    },
    response => {
       console.error("RezervasyonKaydet API Hatası:", response);
       this.loadingdialog=false;
    }
);
    },






  getparabirimi() {
      return ""; // helpers.getparabirimi()
    },
  irtibatDialog() {
    this.$refs.tanitimdialog.open(0);
  },
  getAccountDetails() {
    this.loadingvmodel = true;
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var params = {
      CustomerID: credentials.MusteriID,
      ServiceID: 3,
    };

    this.$http
      .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          auth.HOTELRUNNERUSERNAME = response.body.UserName;
          auth.HOTELRUNNERUSERPASS = response.body.Password;
          this.demoKayit = response.body.Active;
  
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.loadingvmodel = false;
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable";
            this.loadingvmodel = false;
            this.snackbar = true;
          }
        }
      );
  },
  getEklimi(val) {
    var kayitEklimi = this.kisiBilgileri
      .map(function (e) {
        return e.sira;
      })
      .indexOf(val.id);

    if (kayitEklimi == -1) {
      return true;
    } else {
      return false;
    }
  },

  kisiAktar(val) {
    var kayitEklimi = this.kisiBilgileri
      .map(function (e) {
        return e.sira;
      })
      .indexOf(val.id);
    if (kayitEklimi == -1) {
      var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));
      var tip = 0;
      if (val.tip == 1) {
        tip = 1;
      } else if (val.tip == 2) {
        tip = 2;
      } else {
        tip = 0;
      }

      var yeni = {
        id: this.secilenKisi,
        sira: val.id,
        tip: tip,
        Ad: pdrive.Rezervasyon.adresler[val.id].firstName,
        Soyad: pdrive.Rezervasyon.adresler[val.id].lastName,
        TcKimlikNo: pdrive.Rezervasyon.adresler[val.id].tcKimlikNo,
        Ulke: null,
        CoperKisiID: pdrive.Rezervasyon.adresler[val.id].id,
      };

      if (this.secilenKisi == 0) {
        this.TransferData.Email = pdrive.Rezervasyon.adresler[val.id].eMail;
        this.TransferData.Phone = pdrive.Rezervasyon.adresler[val.id].gsm;
      }

      this.kisiBilgileri.splice(this.secilenKisi, 1, yeni);
      this.kisisecDialog = false;
    } else {
      this.text1 = this.$t('Person-added-you-cannot-add-them-again')
      this.snackbar = true;
    }
  },
  kisiKaldir(val) {
    var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

    var kisiid = pdrive.Rezervasyon.adresler[val.id].id;
    var kayitEklimi = this.kisiBilgileri
      .map(function (e) {
        return e.CoperKisiID;
      })
      .indexOf(kisiid);
    var yeni = {
      id: this.kisiBilgileri[kayitEklimi].id,
      sira: null,
      tip: this.kisiBilgileri[kayitEklimi].tip,
      Ad: null,
      Soyad: null,
      TcKimlikNo: null,
      Ulke: null,
      CoperKisiID: null,
    };

    this.kisiBilgileri.splice(kayitEklimi, 1, yeni);
    this.kisisecDialog = false;
  },
  getkisiDurum(a) {
    var tip;
    if (a != 1 && a != 2) {
      tip = 0;
    } else {
      tip = a;
    }

    if (this.secilenKisiTip == a) {
      return true;
    } else {
      return false;
    }
  },
  kisisec(a) {
    this.secilenKisi = this.kisiBilgileri.indexOf(a);
    this.kisisecDialog = true;
    this.secilenKisiTip = a.tip;
  },
  getSaticiBilgileri(val) {
    var Satici = {
      Aciklamalar: "Pax Drive",
      Adres: null,
      Email: null,
      Fax: null,
      GSM: null,
      HavaAlani: null,
      IcDis: 0,
      Isim: "Pax Drive",
      Kod: "PAX",
      PK: null,
      SaticiKonumu: null,
      Sehir: null,
      Tel1: null,
      Tel2: null,
      Teleks: null,
      Tip: 2,
      Ulke: "TR",
      VDaire: null,
      VNo: null,
      Web: null,
      Yer: null,
      Yetkili: null,
    };

    return Satici;
  },
  getPersonInfo(tip) {
    var kisiler = [];

    this.kisiBilgileri.forEach((element) => {
      if (tip == element.tip) {
        var kayit = {
          Name: element.Ad,
          LastName: element.Soyad,
          IdNo: element.TcKimlikNo,
          Nationality: element.Ulke,
        };
        kisiler.push(kayit);
      }
    });

    return kisiler;
  },
  getodaDetay(id, val) {
    if (id == 0) {
      var detay = {
        OdaAd: this.Odaitems.OdaAd,
        OdaGorsel: this.Odaitems.OdaGorsel,
        SinifAd: this.Odaitems.SinifAd,
        OdaOzellik: this.Odaitems.OdaOzellik,
      };
      this.odadetayi = detay;
    } else if (id == 1) {
      var detay = {
        OdaAd: val.OdaAd,
        OdaGorsel: val.OdaGorsel,
        SinifAd: val.SinifAd,
        OdaOzellik: val.OdaOzellik,
      };
      this.odadetayi = detay;
    }

    this.odadetaydialog = true;
  },
  getodaGorsel() {
    if (this.Odaitems.OdaGorsel.length > 0) {
      return this.Odaitems.OdaGorsel[0].Url;
    }
  },
  yetiskinArttir() {
    this.Azalt = false;
    this.yetiskinSayi++;
  },
  yetiskinAzalt() {
    if (this.yetiskinSayi >= 2) {
      this.yetiskinSayi--;
    } else {
      this.Azalt = true;
    }
  },
  TransferKaydet: TransferKaydet,
  UlkeCek: UlkeCek,
 
},
filters: {
  dateformat: function (t) {
    return helpers.dateformat(t);
  },
  coperdateformat: function (t) {
    return helpers.coperdateformat(t);
  },

  moneyformat: function (m) {
    return helpers.moneyformat(m);
  },
  gettime: function (t) {
    return helpers.getTime(t);
  },
  ilkfoto: function (a) {
    return a[0].Url;
  },
},
watch: {
  'TransferResult.PriceDetails.Markup': function (tutar) {
    this.TransferResult.PriceDetails.UserPrice=this.TransferResult.PriceDetails.Markup + this.TransferResult.PriceDetails.SystemPrice;
        },
        'TransferResult.PriceDetails.SystemPrice': function (tutar) {
    this.TransferResult.PriceDetails.UserPrice=this.TransferResult.PriceDetails.Markup + this.TransferResult.PriceDetails.SystemPrice;
        },
  kisiListesi: function (val) {
    this.kisiTipiItems = [];
    var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

    this.kisiBilgileri = [];

    var i = 0;

    val.forEach((element) => {
      // yetişkin tip 0, çocuk 1 ,baby 2

      var tip = 0;

      if (pdrive.Rezervasyon.adresler[element].kisiTip == 1) {
        tip = 1;
      } else if (pdrive.Rezervasyon.adresler[element].kisiTip == 2) {
        tip = 2;
      } else {
        tip = 0;
      }

      var yeni = {
        id: parseInt(i),
        sira: element,
        tip: tip,
        Ad: pdrive.Rezervasyon.adresler[element].firstName,
        Soyad: pdrive.Rezervasyon.adresler[element].lastName,
        TcKimlikNo: pdrive.Rezervasyon.adresler[element].tcKimlikNo,
        Ulke: null,
        CoperKisiID: pdrive.Rezervasyon.adresler[element].id,
      };
      this.kisiBilgileri.push(yeni);

      i = i + 1;
    });
  },
  isimDefault: function (val) {
   
    if (val == true) {
      var i, k, j;

      this.kisiTipiItems = [];

      var top =
        parseInt(this.$route.query.adultCount) +
        parseInt(this.$route.query.childCount) +
        parseInt(this.$route.query.babyCount);

      // yetişkin tip 0, çocuk 1 ,baby 2

      for (i = 0; i < this.$route.query.adultCount; i++) {
        var kayit = {
          id: i,
          tip: 0,
        };
        this.kisiTipiItems.push(kayit);
      }

      for (
        k = i;
        k <
        parseInt(this.$route.query.adultCount) +
          parseInt(this.$route.query.childCount);
        k++
      ) {
        var kayit = {
          id: k,
          tip: 1,
        };
        this.kisiTipiItems.push(kayit);
      }

      for (j = k; j < top; j++) {
        var kayit = {
          id: j,
          tip: 2,
        };
        this.kisiTipiItems.push(kayit);
      }

      this.kisiBilgileri = [];

      i = 0;

      this.kisiTipiItems.forEach((element) => {
        var yeni = {
          id: parseInt(i),
          sira: null,
          tip: element.tip,
          Ad: null,
          Soyad: null,
          TcKimlikNo: null,
          Ulke: null,
          CoperKisiID: null,
        };
        this.kisiBilgileri.push(yeni);
        i++;
      });
    } else {
      this.kisiBilgileri = [];

      if (this.kisiListesi.length != 0) {
        this.kisiTipiItems = [];

        var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

        this.kisiBilgileri = [];

        var i = 0;

        this.kisiListesi.forEach((element) => {
          // yetişkin tip 0, çocuk 1 ,baby 2

          var tip = 0;

          if (pdrive.Rezervasyon.adresler[element].kisiTip == 1) {
            tip = 1;
          } else if (pdrive.Rezervasyon.adresler[element].kisiTip == 2) {
            tip = 2;
          } else {
            tip = 0;
          }

          var yeni = {
            id: parseInt(i),
            sira: element,
            tip: tip,
            Ad: pdrive.Rezervasyon.adresler[element].firstName,
            Soyad: pdrive.Rezervasyon.adresler[element].lastName,
            TcKimlikNo: pdrive.Rezervasyon.adresler[element].tcKimlikNo,
            Ulke: null,
            CoperKisiID: pdrive.Rezervasyon.adresler[element].id,
          };
          this.kisiBilgileri.push(yeni);

          i = i + 1;
        });
      }
    }
  },
  search: {
    handler: function (val, oldVal) {
      if (event != undefined) {
        this.UlkeCek(val, event.target.name);
      }
    },
    deep: true,
  },
  search1(val) {
    // val && this.UlkeCek(val)
  },
},
components: {
  tarihim,
  loadingcomp,
  snackbarcomp,
  caricomp,
  yetkidialog,
  hotelloadingcomp,
  tanitimMail,
  parainputevents,
  parainput
},
};

function beforeMount() {
  // this.login();
}

function UlkeCek(val, id) {
  var bookingParams = JSON.parse(
          window.localStorage.getItem("transferBookingParams")
        );
var params = {
  SessionHeader:{
    SessionId: bookingParams.SessionId,
      SessionToken:bookingParams.SessionToken
    },
  // SearchText: val[id],
  // Language: "TR",
  Country: {
    Id: 0,
    CountryCode: "",
    CountryName: val[id]
  },
  ArkmanCountryId: 0
};




if (val.length >= 1) {
  setTimeout(() => {
    this.$http
      .post(auth.PAXDRIVE_API_URL + "Map/GetCountryList", params, {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(
              auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
            ),
        },
      })
      .then(
        (response) => {
        var country ={
          countrycode:'TR',
          countryName:'TR'
        };
          // this.ulkeitems[id] = response.body;
          this.ulkeItems[id].push(country);
        
        },
        (response) => {
          this.text1 = this.$t('An-error-has-occurred-during-country-search')
          this.snackbar = true;
          this.progress = false;
        }
      );
  }, 500);
}
}

function TransferKaydet() {
 this.UpdatePassengers();
 return;
if (this.$refs.formtransfer.validate()) {
  this.loadingmesaj = this.$t('Your-process-being-completed');
  this.loadingdialog = true;

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    LogInput: {
      UserID: credentials.UserID,
      CustomerID: credentials.MusteriID,
    },
    ReferenceNumber: this.TransferResult.ReferenceNumber,
    FlightNumber: this.TransferData.FlightNumber, //PickupPointId
    Adress: this.TransferData.Adress, //DropPointId
    PickupPointName: this.TransferResult.PickupPointName,
    DropPointName: this.TransferResult.DropPointName,
    Nationality: 'TR',//this.kisiBilgileri[0].Ulke, //
    IdNo: this.kisiBilgileri[0].TcKimlikNo, //
    Name: this.kisiBilgileri[0].Ad, //
    LastName: this.kisiBilgileri[0].Soyad, //
    Email: this.TransferData.Email, //
    Phone: this.TransferData.Phone, //
    DropPointInfo: this.TransferData.DropPointInfo, //bırakılacak yer açıklam
    PickupPointInfo: this.TransferData.PickupPointInfo, // alınacak yer açıklama
    BookingInfo: this.TransferData.BookingInfo, //rezervasyon bilgisi
    PaxAdult: this.getPersonInfo(0),
    PaxChild: this.getPersonInfo(1),
    PaxBaby: this.getPersonInfo(2),
  };

  this.$http
    .post(auth.PAXDRIVE_API_URL + "api/Transfer/GetPrebooking", params, {
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
          ),
      },
    })
    .then(
      (response) => {
        if (response.body.Status == true) {
          if (this.islemTipi == "pdyeni") {
            var transfer = {
              TransferData: this.TransferData,
              PaxDrive: this.TransferResult,
              AdresBilgileri: this.kisiBilgileri,
              pdislem: true,
              pdislemTipi: this.islemTipi,
              CariKodu: this.cariKod,
              SaticiBilgileri: this.getSaticiBilgileri(),
              CardId: response.body.CardId,
              Pnr: response.body.Pnr,
            };

            window.localStorage.setItem(
              "pdtransfer",
              JSON.stringify(transfer)
            );
            this.loadingmesaj = this.$t('Process-completed-being-redirected-reservation-page-registration');

            setTimeout(
              function () {
                this.loadingdialog = false;
                var link = "#/coper/rezervasyon/index/id?islem=pdyeni";
                window.open(link, "_target");
              }.bind(this),
              5000
            );
          } else if (this.islemTipi == "pdget") {
            var pdrive = JSON.parse(
              window.localStorage.getItem("pdtransfer")
            );
            var adres = null;

            var transfer = {
              Rezervasyon: pdrive.Rezervasyon,
              TransferData: this.TransferData,
              AdresBilgileri: this.kisiBilgileri,
              PaxDrive: this.TransferResult,
              pdislem: true,
              pdislemTipi: this.islemTipi,
              SaticiBilgileri: this.getSaticiBilgileri(),
              CardId: response.body.CardId,
              Pnr: response.body.Pnr,
            };

            window.localStorage.setItem(
              "pdtransfer",
              JSON.stringify(transfer)
            );

            this.loadingmesaj = this.$t('Process-completed-being-redirected-reservation-page-registration');

            setTimeout(function () {
              this.loadingdialog = false;
              var link = "#/coper/rezervasyon/index/id?islem=pdget";
              window.open(link, "_target");
            });
          }
        } else {
          this.loadingdialog = false;
           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = this.$t("error-occurred-please-try-again");
        this.snackbar = true;
        this.loadingdialog = false;
      }
    );
}
}
</script>